import { sub_routeService } from '../_services';
import { router } from '../_helpers';

const state = { onRequest: false, sub_routes: [], sub_route: {} };

const actions = {
    get({ dispatch, commit }, id) {
        commit('request');

        sub_routeService.get(id)
            .then(
                resp => {
                    commit('success_data', resp);
                },
                error => {
                    commit('error');
                    dispatch('alert/error', error, { root: true });
                }
            );
    },
    add({ dispatch, commit }, data) {
        commit('request');

        sub_routeService.add(data)
            .then(
                async () => {
                    commit('success');
                    await router.push('/sub_routes');
                    dispatch('alert/success', "Route Added Successfully", { root: true });
                },
                async error => {
                    commit('error');
                    await router.push('/sub_routes');
                    dispatch('alert/error', error, { root: true });
                }
            );
    },
    edit({ dispatch, commit }, data) {
        commit('request');

        sub_routeService.edit(data)
            .then(
                async () => {
                    commit('success');
                    await router.push('/sub_routes');
                    dispatch('alert/success', "Route Updated Successfully", { root: true });
                },
                async error => {
                    commit('error');
                    await router.push('/sub_routes');
                    dispatch('alert/error', error, { root: true });
                }
            );
    },
    get_all({ dispatch, commit }) {
        commit('request');

        sub_routeService.get_all()
            .then(
                (resp) => {
                    commit('success_datas', resp);
                },
                error => {
                    commit('error');
                    dispatch('alert/error', error, { root: true });
                }
            );
    },
    destroy({ dispatch, commit }, id){
      commit('request');

      sub_routeService.destroy(id)
          .then(
              async () => {
                  commit('success');
                  await router.go('/sub_routes');
                  dispatch('alert/success', "Route Deleted Successfully", { root: true });
              },
              async error => {
                  commit('error');
                  await router.go('/sub_routes');
                  dispatch('alert/error', error, { root: true });
              }
          );
    },
    get_sub_route_by_route({ dispatch, commit }, data) {
        commit('request');

        sub_routeService.get_sub_route_by_route(data)
            .then(
                (resp) => {
                    commit('success_datas', resp);
                },
                error => {
                    commit('error');
                    dispatch('alert/error', error, { root: true });
                }
            );
    },
    get_sub_route_by_account({ dispatch, commit }, data) {
        commit('request');

        sub_routeService.get_sub_route_by_account(data)
            .then(
                (resp) => {
                    commit('success_datas', resp);
                },
                error => {
                    commit('error');
                    dispatch('alert/error', error, { root: true });
                }
            );
    },
};
const getters = {
  onRequest: state => {
    return state.onRequest
  },
  sub_routes: state => {
    return state.sub_routes
  },
  sub_route: state => {
    return state.sub_route
  },
};

const mutations = {
    request(state) {
        state.onRequest = true;
        state.sub_route = {};
        state.sub_routes = [];
    },
    success(state) {
      state.onRequest = false;
    },
    success_data(state, data) {
      state.onRequest = false;
      state.sub_route = data;
    },
    success_datas(state, data) {
      state.onRequest = false;
      state.sub_routes = data;
    },
    error(state) {
        state.onRequest = false;
    },
};

export const sub_routes = {
    namespaced: true,
    state,
    actions,
    getters,
    mutations
};
